import React from "react";

interface IndicatorButtonProps {
  isActive: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  isLeft?: boolean;
  isRight?: boolean;
  icon?: React.SVGProps<SVGAElement>;
}

export const IndicatorButton: React.FC<IndicatorButtonProps> = ({
  isActive,
  onClick,
  label,
  isLeft,
  isRight,
  icon,
}) => (
  <button
    type="button"
    style={{
      backgroundColor: isActive ? "rgb(0,0,0,0.5)" : "rgb(0,0,0,0.1)",
      color: "#ffffff",
      minWidth: "30px",
      borderRadius: isLeft
        ? "5px 0 0 5px"
        : isRight
        ? "0px 5px 5px 0px"
        : "0 0px 0px 0px",
      border: "none",
      padding: "5px",
    }}
    onClick={onClick}
    aria-label={label}
  >
    {icon ? icon : label}
  </button>
);
